import { NavigationItem } from "../navigation-item"
import { IncentivesSubItem } from "../subitems/incentives-subitem"
import { VeScaleLockSubItem } from "../subitems/vescale-lock-subitem"
import { VotingLockSubItem } from "../subitems/voting-lock-subitem"
import { LockCreateTab, LockExtendTab, LockIncreaseTab, LockOverviewTab } from "../tabs/lock-tabs"

export class LockNavigationItem extends NavigationItem {
  readonly id = "lock"
  readonly label = "veSCALE"
  readonly href = "/lock"
  readonly iconName = "lock-icon"
  readonly isExternal = false

  readonly tabs = [new LockOverviewTab(), new LockCreateTab(), new LockExtendTab(), new LockIncreaseTab()]

  readonly subItems = [new VeScaleLockSubItem(), new VotingLockSubItem(), new IncentivesSubItem()]
}
